import styled from "styled-components";

export const StyledDropzoneCol = styled.div<{ className: string }>`
  margin-top: 0;
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    margin-top: -4.8rem;
  }
`;
